import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {PATHS } from 'src/config/app'
// import AnalyticsService from '@/services/AnalyticsService'

// ROUTES
import Loading from '@/components/loading/Loading'
import Home from '@/components/home/Home' 

// INIT
Vue.use(Router)
const router = new Router({
  base: '/',

  // Modes
  mode: 'abstract', // eg /#/mypage
  // mode: 'history', // eg /mypage (requires htaccess or equivalent for deploy)
  // mode: 'abstract', // internal routing, no url change

  // Routes
  routes: [
    {
      path: '/'+ PATHS.LOADING,
      name: PATHS.LOADING,
      component: Loading,
    },

    {
      path: '*',
      redirect: { name:PATHS.HOME }
    },
    
    {
      path: '/',
      name: PATHS.HOME,
      component: Home,
    },
    
  ],
})
export default router

// ROUTE GUARD
router.beforeEach((to, from, next) => {
  if (to.name !== 'loading' && !store.state.app.loading.completed) {

    let noLandingRoute = ['loading'].includes(to.name)
    if (typeof to.name === 'string' && !noLandingRoute) {
      store.commit('app/setRouteAfterLoad', to.path)
    }
    return next({ name: 'loading' })
  }
  next()
})

// START IF ABSTRACT MODE
if (router.mode === 'abstract') {
  router.replace('/').catch(err => {})
}

// AFTER HOOK
router.afterEach((to) => {
  store.commit('app/setRoute', {
    parent: to.matched[0].name,
    child: (to.matched[1] || { name: null }).name,
  })
  // AnalyticsService.sendPageview(to.fullPath)
})

window.router = router
